import { PreventiveActivitiesSettingsContainerState } from "@/Portfolio/Components/PreventiveActivitiesSettingsContainer";

class PreventiveActivitiesSearchSettings {
    public ShowAllClinicians: boolean;
    public ShowAllStatuses: boolean;
    public ShowAllRequestingStaff: boolean;
    public ShowAllSites: boolean;
    public ClinicianIds: string[];
    public RequestingStaffIds: string[];
    public SiteIds: string[];
    public Statuses: string[];
    public IsOnlyWithinReminderPeriodChecked: boolean;

    public constructor(init?: Partial<PreventiveActivitiesSearchSettings>) {
        Object.assign(this, init);
    }

    public static fromModel(model: PreventiveActivitiesSettingsContainerState): PreventiveActivitiesSearchSettings {
        const helper = cacheStore.Helper;

        return new PreventiveActivitiesSearchSettings({
            ShowAllClinicians: model.showAllClinicians,
            ShowAllSites: model.showAllSites,
            ShowAllStatuses: model.showAllStatuses,

            ClinicianIds: helper.GetCheckedItemsFromICheckableList(model.clinicians.toImmutable()).map(p => p.Id).toArray(),
            RequestingStaffIds: helper.GetCheckedItemsFromICheckableList(model.requestingStaff.toImmutable()).map(p => p.Id).toArray(),
            SiteIds: helper.GetCheckedItemsFromICheckableList(model.sites.toImmutable()).map(p => p.Id).toArray(),
            Statuses: helper.GetCheckedItemsFromICheckableList(model.statuses.toImmutable()).map(p => p.Id).toArray(),
            IsOnlyWithinReminderPeriodChecked: model.isOnlyWithinReminderPeriodChecked
        });
    }
}

export { PreventiveActivitiesSearchSettings };
